/**
 * Returns true when the PSP Management entry should be hidden from navigation.
 *
 * This hides only the `psp_management` item when the related feature flag is disabled.
 */
export const isPspManagementHidden = (
  appNameId: string,
  pspEnabled: boolean,
): boolean => !pspEnabled && appNameId === 'psp_management';
